import {objectFromEntries} from '@benchling/js-utils';

import {CidIdMap} from 'notebook/notes/NoteConstants';

export type IdToCidMap = Record<string, string>;
export type GetCachedCidFunction = (id: string, errorContext: object) => string;

// Convert {cid: id} into {id: cid}
export function invertStringMapping(cidToIdMap: CidIdMap): IdToCidMap {
  return objectFromEntries(Object.entries(cidToIdMap).map(([cid, id]) => [id, cid]));
}
